import { Input, Text } from "@mantine/core";
import { useMemo } from "react";
import { useFormContext, useWatch } from "react-hook-form";
import Select from "src/components/shared/_FormInputs/Select";
import { useCheckPerm, useIsOnline } from "src/hooks";
import { vesselTypeData } from "src/mock/selectOptions";
import { InputStyledWrapper } from "src/pages/Settings/YachtSetup/VesselParticulars/YachtSetup.styled";

const VesselTypeInput = () => {
  const { control, register } = useFormContext();
  const isOnline = useIsOnline();
  const checkPerm = useCheckPerm();
  const readOnly = useMemo(
    () => !checkPerm("editparticulars") || !isOnline,
    [checkPerm, isOnline],
  );
  const type = useWatch({ control, name: "vtype" });
  return (
    <>
      <InputStyledWrapper mt={10}>
        <Text size={"sm"} w="50%">
          Vessel Type
        </Text>
        <Select
          w="50%"
          name="vtype"
          control={control}
          data={vesselTypeData}
          readOnly={readOnly}
        />
      </InputStyledWrapper>
      {type === "VT8" && (
        <InputStyledWrapper mt={10}>
          <Text size={"sm"} w="50%">
            Specify Vessel Type
          </Text>
          <Input w="50%" {...register("vtypeother")} readOnly={readOnly} />
        </InputStyledWrapper>
      )}
    </>
  );
};

export default VesselTypeInput;
